// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.criteria.RentalManagerUserPropertyCriteriaWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, UserPropertyCriteriaGetResponseWebDto } from '../..';

interface GetParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyCriteriaWebApiHandler_get_Path = '/api/web/v1/users/properties/criteria/get';

/**
 * Get criteria for a listing
 */
export const RentalManagerUserPropertyCriteriaWebApiHandler_get = (getParams: GetParams, client = getClient()) => {
  return httpFrontEndRequest<GetParams, never, UserPropertyCriteriaGetResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyCriteriaWebApiHandler_get_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
